module.exports = __webpack_public_path__ + "static/media/electronic-school-bell-81033.b1936175.mp3";